export default {"src":"/_next/static/media/outdoor_40.754dabeb.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};